import type { StatusKeyQuote } from "../types";

type QuoteStatus = {
  color: string;
  label: string;
};

export const statusQuote: Record<StatusKeyQuote, QuoteStatus> = {
  pending: { label: "Pendiente", color: "warning" },
  completed: { label: "Completada", color: "success" },
  rejected: { label: "Rechazada", color: "error" },
};


